// extracted by mini-css-extract-plugin
module.exports = {"root":"HomeCarousel_root__2BUXX","container":"HomeCarousel_container__3rSjk","left":"HomeCarousel_left__xQyXf","right":"HomeCarousel_right__11jkR"};